import React from 'react';

import { dib } from '../components/HeroBusiness/Data';

import HeaderMenu from '../components/HeaderMenu';
import HeroBusiness from '../components/HeroBusiness';
import Footer from '../components/Footer';


const Dib = () => {
  return (
    <>
    <HeaderMenu />
    <HeroBusiness {...dib}/>
    <Footer />
      
    </>
  )
}

export default Dib
